var map = {
	"./1.jpg": "8554",
	"./2.jpg": "405a",
	"./3.jpg": "11d9",
	"./4.jpg": "bafb",
	"./5.jpg": "4d0f",
	"./cursor3.png": "213f",
	"./dasha.jpg": "5ea8",
	"./elonmusk.jpg": "7754",
	"./hlaponinstar.jpg": "97f3",
	"./hookahking.jpg": "78de",
	"./jordan.jpg": "f2c3",
	"./kuchanskiy.jpg": "ce21",
	"./malun.jpg": "85db",
	"./malva.jpg": "e5f6",
	"./misha1.jpg": "60da",
	"./misha2.jpg": "43bc",
	"./mishaonthebed.jpg": "182a",
	"./nav.jpg": "814e",
	"./photo_2020-08-27_17-23-59.jpg": "dee0",
	"./pusha.jpg": "d136",
	"./putin.jpg": "4d0e",
	"./schumacher.jpg": "8929",
	"./terentos.jpg": "f210",
	"./tsaruk.jpg": "35f4",
	"./vishnya.jpg": "9da7",
	"./withbd.gif": "bef8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";